<script setup lang="ts">
import { defineRule, Field as VeeField, Form as VeeForm } from 'vee-validate'

import { emailValidator, requiredValidator } from '@/utils/rulesOfValidate'

import { useAppStore } from '@/store/app/app'
import { SnackbarType } from '@/store/app/app.types'
import { useUserStore } from '@/store/user/user'

import { Success } from '@/api/results'

const { isMobile } = useResponsive()

const { changeInfo } = useUserStore()
const { showSnackbar } = useAppStore()

const email = ref('')

const isLoading = ref(false)

defineRule('email', emailValidator)
defineRule('required', requiredValidator)

const onSubmit = async () => {
  isLoading.value = true

  const result = await changeInfo({
    email: email.value,
  })

  if (result instanceof Success) {
    showSnackbar({
      message: 'Изменения сохранены',
      type: SnackbarType.SUCCESS,
    })

    isLoading.value = false

    return
  }

  showSnackbar({
    message: 'Что-то пошло не так, попробуйте позже',
    type: SnackbarType.MESSAGE,
  })

  isLoading.value = false
}
</script>

<template>
  <div class="email-factoid">
    <div class="email-factoid__info">
      <div class="email-factoid__title">
        Подпишитесь на&nbsp;рассылку акций и&nbsp;промокодов
      </div>

      <div class="email-factoid__text">
        Нажимая на&nbsp;кнопку, вы&nbsp;соглашаетесь с&nbsp;обработкой
        персональных данных
      </div>
    </div>

    <vee-form v-slot="{ handleSubmit }" class="email-factoid__form">
      <vee-field
        v-slot="{ field, errors }"
        name="E-mail"
        rules="email|required"
        value=""
      >
        <the-input
          v-model="email"
          v-bind="field"
          class="email-factoid__input"
          type="email"
          autocomplete="off"
          placeholder="Введите E-mail"
          hide-details
          :size="isMobile ? 'sm' : 'lg'"
          :error-messages="errors"
        />
      </vee-field>

      <the-button
        class="email-factoid__button"
        type="button"
        variant="secondary"
        block
        :loading="isLoading"
        @click="handleSubmit(onSubmit)"
      >
        Подписаться
      </the-button>
    </vee-form>
  </div>
</template>

<style lang="scss" scoped>
.email-factoid {
  gap: 0 30px;
  align-items: center;
  width: 100%;
  padding: 16px;
  background-color: var(--ui-color-sandy-100);
  border-radius: 20px;

  @include media('>=desktop-mini') {
    display: flex;
    justify-content: space-between;
    padding: 24px;
  }

  &__info {
    margin-bottom: 24px;

    @include media('>=desktop-mini') {
      margin-bottom: 0;
    }
  }

  &__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 800;
    line-height: 20px;
    color: var(--ui-text-primary);
    letter-spacing: -0.01em;

    @include media('>=desktop-mini') {
      margin-bottom: 4px;
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__text {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-text-secondary);
    letter-spacing: -0.01em;
  }

  &__form {
    @include media('>=desktop-mini') {
      display: flex;
      gap: 8px;
    }
  }

  &__input {
    margin-bottom: 14px;

    @include media('>=desktop-mini') {
      width: 200px !important;
      margin-bottom: 0;
    }

    @include media('>=desktop') {
      width: 408px !important;
    }
  }

  &__button {
    @include media('>=desktop-mini') {
      max-width: 160px;
    }
  }
}
</style>
